export function priceRowKey(item) {
  return item?.nomenclature_uid ?? item?.article ?? item?.name ?? "";
}

export function filterLicenseCalculatorPrices(prices) {
  if (!Array.isArray(prices)) {
    return [];
  }
  return prices.filter(
    (p) => p?.kind === "license" && p?.is_active === true,
  );
}

export function normalizeLicenseQuantity(raw) {
  const num = Number(raw);
  if (!Number.isFinite(num) || num < 0) {
    return 0;
  }
  return Math.floor(num);
}

export function parsePriceAmount(value) {
  if (value === null || value === undefined || value === "") {
    return 0;
  }
  const num = Number(String(value).replace(/\s/g, "").replace(",", "."));
  return Number.isFinite(num) ? num : 0;
}

export function computeLicenseCalculatorTotals(prices, quantities) {
  let totalWithVat = 0;
  let totalWithoutVat = 0;

  for (const item of prices) {
    const key = priceRowKey(item);
    const qty = quantities[key] ?? 0;
    totalWithVat += parsePriceAmount(item.price_with_vat) * qty;
    totalWithoutVat += parsePriceAmount(item.price_without_vat) * qty;
  }

  return { totalWithVat, totalWithoutVat };
}

/** @returns {{ key: string, name: string, qty: number }[]} for qty > 0 */
export function buildLicenseProductSummaryLines(prices, quantities) {
  if (!Array.isArray(prices)) {
    return [];
  }
  const lines = [];
  for (const item of prices) {
    const key = priceRowKey(item);
    const qty = quantities[key] ?? 0;
    if (qty < 1) {
      continue;
    }
    const name = String(item?.name ?? "").trim();
    if (!name) {
      continue;
    }
    lines.push({ key, name, qty });
  }
  return lines;
}
